// extracted by mini-css-extract-plugin
export var cardIcon = "_t-5";
export var cardIconUnframed = "_t-9";
export var checkboxCard = "_t-0";
export var checkboxCardSelected = "_t-4";
export var disabled = "_t-2";
export var interactive = "_t-1";
export var outerBorder = "_t-3";
export var spacerMedium = "_t-8";
export var spacerSmall = "_t-7";
export var spacerXsmall = "_t-6";